import { useStepsStore } from '../../stores/StepsStore';
import { IStepsTypes } from '../../typings';
import { StepProgress } from './StepProgress';

export const RegistrationHeader = (props: { choosenSteps: IStepsTypes[]; }) => {
    const { currentStep } = useStepsStore();
    return <div className="ncf-header">
        <StepProgress steps={props.choosenSteps} currentStep={currentStep} />
        <div className="trustpilot-widget" style={{ fontSize: "font-size: 0;" }} data-locale="en-GB" data-template-id="5419b732fbfb950b10de65e5"
            data-businessunit-id="5720cd9b0000ff00058c189a" data-style-height="40px" data-style-width="100%" >
            <a href="https://uk.trustpilot.com/review/www.careline.co.uk" target="_blank" rel="noopener">Trustpilot</a>
        </div>
    </div>;
}